export const createOrderStep3Validator = (area, pano_window_count, reg_window_count, request_price, final_price, rooms_count, bathroom_count, isCustomPackage, type_cleaning) => {
  const areaLabel = document.getElementById("area");
  const regWindowLabel = document.getElementById("reg_window");
  const panWindowLabel = document.getElementById("pan_window");
  const requestPriceLabel = document.getElementById("request_price");
  const roomsCountLabel = document.getElementById("rooms_count");
  const bathroomCountLabel = document.getElementById("bathroom_count");

  if (!area) {
    if (areaLabel) {
      areaLabel.scrollIntoView({behavior: 'smooth', block: "center"});
      const inputElement = areaLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = areaLabel.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        areaLabel.appendChild(errorMessageSpan);
      }
    }

    return false;
  }

  if (type_cleaning === "Генеральне" && (!rooms_count || !bathroom_count) && isCustomPackage) {
    if (!rooms_count && roomsCountLabel) {
      roomsCountLabel.scrollIntoView({behavior: 'smooth', block: "center"});
      const inputElement = roomsCountLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = roomsCountLabel.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        roomsCountLabel.appendChild(errorMessageSpan);
      }
    }

    if (!bathroom_count && bathroomCountLabel) {
      bathroomCountLabel.scrollIntoView({behavior: 'smooth', block: "center"});
      const inputElement = bathroomCountLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = bathroomCountLabel.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        bathroomCountLabel.appendChild(errorMessageSpan);
      }
    }

    return false;
  }

  if ((type_cleaning === "Миття вікон" || type_cleaning === "Генеральне") && (!pano_window_count || !reg_window_count)) {
    if (!pano_window_count && panWindowLabel) {
      panWindowLabel.scrollIntoView({behavior: 'smooth', block: "center"});
      const inputElement = panWindowLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = panWindowLabel.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        panWindowLabel.appendChild(errorMessageSpan);
      }
    }

    if (!reg_window_count && regWindowLabel) {
      regWindowLabel.scrollIntoView({behavior: 'smooth', block: "center"});
      const inputElement = regWindowLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = regWindowLabel.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = "Заповніть це поле";
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        regWindowLabel.appendChild(errorMessageSpan);
      }
    }

    return false;
  }

  if (!request_price || request_price < final_price) {
      requestPriceLabel.scrollIntoView({behavior: 'smooth', block: "center"});
      const inputElement = requestPriceLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.border = "1px solid #F04438";
      }

      let errorMessageSpan = requestPriceLabel.querySelector("span");
      if (!errorMessageSpan) {
        errorMessageSpan = document.createElement("span");
        errorMessageSpan.textContent = !request_price ? "Заповніть це поле" : `Ціна повинна бути більше ніж ${final_price} грн`;
        errorMessageSpan.style.color = "#F04438";
        errorMessageSpan.style.fontSize = "14px";
        errorMessageSpan.style.fontWeight = "500";
        errorMessageSpan.style.lineHeight = "20px"; /* 142.857% */
        requestPriceLabel.appendChild(errorMessageSpan);
      }

      return false;
  }

  return true;
}
